import { render } from "./MediaUpload.vue?vue&type=template&id=036ddc7e"
import script from "./MediaUpload.vue?vue&type=script&lang=js"
export * from "./MediaUpload.vue?vue&type=script&lang=js"

import "./MediaUpload.vue?vue&type=style&index=0&id=036ddc7e&lang=scss"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__